import {
    Box,
    Grid,
    Button,
    ButtonGroup,
    Typography,
    Backdrop,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
  } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CollapseSection from "../../../components/ui/CollapseSection";
import {
    GetUserCountries,
    setState,
    GetCustomerNumber,
    GetSalesOrderNumberLineItemForDelete,
    getDataSourcesRecordsForDelete,
    DeleteDataSourceRows,
    reset,
    GetPeriods,
  } from "../centralAdminSlice";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import SharedComponent from "../SharedComponent";
import MultiSelectSalesOrderRecordDelete from "./MultiSelectSalesOrderRecordDelete";
import MultiSelectLineItemRecordDelete from "./MultiSelectLineItemRecordDelete";
import moment from "moment";
import muiConfig from '../../../assets/MuiConfig.json'

  export default function RecordDeletion() {
    const dispatch = useDispatch();
    const centralAdmin = useSelector((state) => state.centralAdmin);
    const {
      countries,
      selectedCountryDelete,
      selectedCountryIDDelete,
      selectedDataLineItemsDelete,
      isLoading,
      selectedRowIdsDelete,
      SelectedEC,
      Periods,
      selectedPeriods,
      selectedDataSalesOrdersDelete, 
      SalesOrderListDelete,
      LineItemListDelete,
      DeleteRecords,

    } = centralAdmin;

    const loginState = useSelector((store) => store.login);
    const { globalSelectedCountryName,globalSelectedCountryID,} = loginState           

    const [selectedRowID, setSelectedRowID] = useState([]);
    const [open, setOpen] = React.useState(false);    

    useEffect(() => {
      dispatch(reset("OnRefresh"));
        if (countries.length <= 0) {
          dispatch(GetUserCountries({ method: "Get" }));
        }
        if (Periods.length <= 0) {
          dispatch(GetPeriods({ method: "Get" }));
        }        
        if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
          dispatch(setState("selectedCountryDelete", globalSelectedCountryName));
          dispatch(setState("selectedCountryIDDelete", globalSelectedCountryID));
        }
        else{
          dispatch(setState("selectedCountryDelete", ""));
          dispatch(setState("selectedCountryIDDelete", null));
      }        

      }, []);

      // useEffect(() => {
      //   if (Periods.length <= 0) {
      //     dispatch(GetPeriods({ method: "Get" }));
      //   }
      // }, []);

    const handleCountryChange = (e) => {
      debugger;
        dispatch(reset("OnCountryChangeDelete"));
        const name = e.target.value;
    
        const countryID = countries.find(
          (country) => country.countryName === name
        ).countryID;
        dispatch(setState("selectedCountryDelete", name));
        dispatch(setState("selectedCountryIDDelete", countryID));
      };

    const handleECChange = (e) => {
      debugger;
      dispatch(reset("OnECChange"));
      console.log(selectedPeriods);
        const EC = e.target.value;
        dispatch(setState("SelectedEC", EC));
      };
      
    const handlePeriodsChange = (e) => {
      dispatch(reset("OnPeriodChangeDelete"));
      console.log(SelectedEC);
      const period = e.target.value;
      dispatch(setState("selectedPeriods",period));
      if(selectedCountryIDDelete===null || selectedCountryIDDelete === undefined || selectedCountryIDDelete === "" || SelectedEC===null || SelectedEC === undefined || SelectedEC === ""){
        return;
      }      
      let obj = {
        selectedPeriods: period,
        selectedSalesOrder: "",
      };
      dispatch(GetSalesOrderNumberLineItemForDelete(obj));
    };  

  const  DeleteOrder=()=>{
    debugger;
    let obj = {
      countryID: selectedCountryIDDelete,
      period: selectedPeriods,
      eC: SelectedEC,
      salesOrder: selectedDataSalesOrdersDelete.join(),
      lineItem: selectedDataLineItemsDelete.join(),
    };
     console.log(selectedRowIdsDelete); 
    //  dispatch(DeleteDataSourceRows(selectedRowID)).then(() => {
    //   dispatch(getDataSourcesRecordsForDelete(obj));
    // });
    dispatch(DeleteDataSourceRows(selectedRowID))
    .then(() => handleDialogClose())
    .then(() => dispatch(getDataSourcesRecordsForDelete(obj)));
    }    

    const onRowsSelectionHandler = (ids) => {
      dispatch(setState("selectedRowIdsDelete", ids));
      setSelectedRowID(ids);
    };    

    const handleDialogClickOpen = () => {
      setOpen(true);
    };
  
    const handleDialogClose = () => {
      setOpen(false);
    };

    const handleDisplay = () => {
      if (!selectedCountryDelete) {
        dispatch(setState("isFailed_Info", "Please select a country."));
        dispatch(setState("isFailed", true));
        return;
      }
      if (SelectedEC.length <= 0) {
        dispatch(setState("isFailed_Info", "Please select EFS/Consumption."));
        dispatch(setState("isFailed", true));
        return;
      }
  
      if (!selectedPeriods) {
        dispatch(setState("isFailed_Info", "Please select a period."));
        dispatch(setState("isFailed", true));
        return;
      }
      if (selectedDataSalesOrdersDelete.length <= 0) {
        dispatch(setState("isFailed_Info", "Please select a sales order."));
        dispatch(setState("isFailed", true));
        return;
      }
      if (selectedDataLineItemsDelete.length <= 0) {
        dispatch(setState("isFailed_Info", "Please select a line item number."));
        dispatch(setState("isFailed", true));
        return;
      }
  
      let obj = {
        countryID: selectedCountryIDDelete,
        period: selectedPeriods,
        eC: SelectedEC,
        salesOrder: selectedDataSalesOrdersDelete.join(),
        lineItem: selectedDataLineItemsDelete.join(),
      };
      dispatch(getDataSourcesRecordsForDelete(obj));
    };    

    const columns = [
      {
        field: "period",
        headerName: "Period",
        flex: 1.8,
        valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY')
      },
      {
        field: "attribute9",
        headerName: "Sales Order Number",
        flex: 1.5,
      },
  
      {
        field: "attribute10",
        headerName: "Line Item Number",
        flex: 1.5,
      },
  
      {
        field: "measureName1",
        headerName: "Intended Consumption",
        flex: 1.5,
        align: "center",
        headerAlign: "center",
      },

      {
        field: "measureName2",
        headerName: "Original Actual Consumption",
        flex: 1.5,
        align: "center",
        headerAlign: "center",
      },
      
      {
        field: "measureName3",
        headerName: "Actual Consumption",
        flex: 1.5,
        align: "center",
        headerAlign: "center",
      },      
    ];   

    return (
<CollapseSection title="Records Deletion">
<Box mt={5}>
<Grid container columns={12} columnGap={2} rowGap={2}>
<Grid item sm={1.95}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              value={countries.length > 0 ? selectedCountryDelete : ""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
            >
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>   
          <Grid item sm={1.95}>
              <TextField
                variant="outlined"
                label="EFS/Consumption"
                select={true}
                value={SelectedEC ? SelectedEC : ""}
                onChange={handleECChange}
                size="small"
                fullWidth
              >
                <MenuItem value="0">Consumption</MenuItem>
                <MenuItem value="1">EFS</MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={1.95}>
            <TextField
              variant="outlined"
              label="Period"
              select={true}
              value={selectedPeriods.length > 0 ? selectedPeriods : ""}
              onChange={handlePeriodsChange}
              fullWidth
              size="small"
            >
              {Periods.length > 0
                ? Periods.map((month, index) => {
                    return (
                      <MenuItem
                        key={month}
                        value={month}
                      >
                        {month}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>    
          {selectedPeriods !== "" && (
            <Grid item sm={1.95}>
              <MultiSelectSalesOrderRecordDelete SalesOrder={SalesOrderListDelete} />
            </Grid>
          )}
          {selectedDataSalesOrdersDelete.length > 0 && (
            <Grid item sm={1.95}>
              <MultiSelectLineItemRecordDelete LineItem={LineItemListDelete} />
            </Grid>
          )} 
        
          <Grid item sm={1.5}>
            <Box justifyContent="center" display="flex">
              <Button 
            sx={{
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                mt: 1,
                mr: 2,
                "&:hover": {
                  bgcolor: "darkred.main",
                },
              }}                  
              variant="contained" onClick={handleDisplay}
              >
                Search
              </Button>
            </Box>
          </Grid>                                      
</Grid>
</Box>
<Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress />
      </Backdrop>
      <SharedComponent />
      {DeleteRecords.length > 0 && (
        <Box
          mt={2}
          sx={{
            width: "100%",
            minHeight: "200px",
            display: DeleteRecords ? "block" : "none",
          }}
        >
          <DataGridPro
            style={{ maxHeight: "calc(100vh - 130px)" }}
            disableColumnMenu
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                position: "sticky",
              },
              "& .MuiDataGrid-columnHeaders": {
                maxHeight: "168px !important",
              },
            }}
            rowHeight={70}
            rows={DeleteRecords || []}
            columns={columns}
            getRowId={(row) => row?.dataSourceRowID}
            onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            initialState={{
              pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
            pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
      <Box my={2} />
      <Grid
        container
        columns={12}
        justifyContent="flex-end"
        alignItems="right"
        my={2}
      >
        <ButtonGroup variant="text" aria-label="Basic button group">
          {selectedRowIdsDelete.length > 0 && (
            <Button variant="contained" 
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              mt: 1,
              mr: 2,
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}
            onClick={handleDialogClickOpen}
            >
              Delete Records
            </Button>
          )}
        </ButtonGroup>
      </Grid>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           Are you sure you want to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            mr: 2,
            "&:hover": {
              bgcolor: "darkred.main",
            },
          }}          
          onClick={handleDialogClose}>No</Button>
          <Button 
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            mr: 2,
            "&:hover": {
              bgcolor: "darkred.main",
            },
          }}
          onClick={DeleteOrder} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

</CollapseSection>
    );

  }